/* What Comes With Your CLEAR Kit - click an image to enlarge it.
   One dialog per section, filled in on click. No dependencies.

   Scoped per section rather than per page: the section can legitimately appear
   more than once, and a page-level singleton would have them fight over one
   dialog. */
(function () {
  var sections = document.querySelectorAll('.cki');
  if (!sections.length) return;

  Array.prototype.forEach.call(sections, function (root) {
    var lb = root.querySelector('[data-cki-lb]');
    if (!lb) return;

    var img     = lb.querySelector('[data-cki-lb-img]');
    var elTitle = lb.querySelector('[data-cki-lb-title]');
    var elBody  = lb.querySelector('[data-cki-lb-body]');
    var closeEl = lb.querySelector('[data-cki-lb-close]');
    var opener  = null;
    var scrollY = 0;

    function open(btn) {
      opener = btn;
      var full = btn.getAttribute('data-full');
      var thumb = btn.querySelector('img');

      // Show the thumbnail immediately so the box never opens empty on a slow
      // connection, then swap in the full-size file once it has loaded.
      if (thumb && thumb.currentSrc) img.src = thumb.currentSrc;
      img.alt = (thumb && thumb.alt) || btn.getAttribute('data-title') || '';
      if (full) {
        var big = new Image();
        big.onload = function () { img.src = full; };
        big.src = full;
      }

      elTitle.textContent = btn.getAttribute('data-title') || '';
      elBody.textContent  = btn.getAttribute('data-body') || '';

      // Lock the page behind the dialog without losing the reading position.
      scrollY = window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.overflow = 'hidden';

      lb.hidden = false;
      closeEl.focus();
    }

    function close() {
      lb.hidden = true;
      img.removeAttribute('src');
      document.body.style.overflow = '';
      if (opener && document.contains(opener)) {
        opener.focus();
        // Safari can scroll the focused element into view and shift the page.
        window.scrollTo(0, scrollY);
      }
      opener = null;
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cki-zoom]') : null;
      if (btn) { open(btn); return; }
      if (e.target.closest && e.target.closest('[data-cki-lb-close]')) { close(); return; }
      // Clicking the backdrop, but not the panel inside it, closes.
      if (e.target === lb) close();
    });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      // Keep focus inside the dialog: it only holds one control, so Tab stays put.
      if (e.key === 'Tab') { e.preventDefault(); closeEl.focus(); }
    });
  });
})();
